import React from 'react'
import ImageMedia from './ImageMedia'
import { lawwdLogo, lawwdSymbol, lawwdWhite } from '../../assets'
import { twMerge } from 'tailwind-merge'
// import { Link } from 'react-router-dom';

const Logo = ({ src, css, className }) => {
  switch (src) {
    case 'white':
      src = lawwdWhite
      break
      case 'symbol':
        src = lawwdSymbol
        css = "w-8 !h-8"
        break
        default:
          src = lawwdLogo
          css = " h-4 lg:h-4 "
      break
  }
  return (
    // <Link to={"/"} id='logo' className=''>
    <ImageMedia
      title='LAWWD'
      bypass
      className={twMerge('flex relative shrink-0 object-contain', css, className)}
      src={src}
    />
    // </Link>
  )
}

export default Logo
